import Drawer from "@material-ui/core/Drawer";
import { makeStyles } from "@material-ui/core/styles";
import React, { useContext, useState } from "react";
import TasksListView from "../../components/tasks/TasksListView";
import TaskView from "../../components/tasks/TaskView";
import { MobileContext } from "../Mobile";

const drawerWidth = "100vw";

const useStyles = makeStyles(theme => ({
  menuButton: {
    marginRight: theme.spacing(2)
  },
  searchButton: {
    marginLeft: theme.spacing(2)
  },
  filterButton: {
    marginLeft: theme.spacing(2)
  },
  title: {
    flexGrow: 1
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: "#fafafa"
  }
}));

const Tasks = () => {
  const classes = useStyles();
  const { onDrawerOpen } = useContext(MobileContext);
  const [task, setTask] = useState(null);

  const handleSelectTask = task => {
    setTask(task);
  };

  return (
    <>
      <Drawer
        className={classes.drawer}
        open={Boolean(task)}
        anchor="right"
        classes={{
          paper: classes.drawerPaper
        }}
      >
        <TaskView
          mobile
          task={task}
          onSelectedTask={handleSelectTask}
          onClose={() => handleSelectTask(null)}
        />
      </Drawer>

      <TasksListView task={task} onSelectedTask={handleSelectTask} onDrawerOpen={onDrawerOpen} />
    </>
  );
};

export default Tasks;
